import { indexItems } from '@/mocks/anime';

export default function Index() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            专题索引
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            按主题快速浏览动漫资源，总有一个专题适合你
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {indexItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-100 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200/50 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <h3 className="font-heading text-base font-bold text-foreground-950 group-hover:text-primary-600 transition-colors flex-1">
                    {item.title}
                  </h3>
                  <span className="px-2 py-0.5 bg-primary-100 text-primary-700 text-xs font-medium rounded-full whitespace-nowrap">
                    {item.count}
                  </span>
                </div>
                <p className="text-foreground-600 text-xs leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}